import React, { useRef, useEffect, useState } from 'react'

import { Header } from '../../components/Header'
import { Footer } from '../../components/Footer'

export const BookingProcessed = () => {
    return (
        <>
            <Header />
            <div id="titlebar">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">

                            <h2>Booking Processed</h2>

                            {/* <!-- Breadcrumbs --> */}
                            <nav id="breadcrumbs">
                                <ul>
                                    <li><a href="#">Home</a></li>
                                    <li>Booking Processed</li>
                                </ul>
                            </nav>

                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-md-12">

                        <div className="booking-confirmation-page">
                            <i className="fa fa-check-circle"></i>
                            <h2 className="margin-top-30">Thanks for your booking!</h2>
                            <p>You'll receive a confirmation email at mail@example.com</p>
                            <a href="dashboard-invoice.html" className="button margin-top-30">View Invoice</a>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}